export const TEMPLATE_NAME_ENUMS = {
  HOPI: "HOPI",
  HOPI_PEDIATRIC: "HOPI_PEDIATRIC",
  OBGYN: "OBGYN",
  PPFM: "PPFM",
  PEV: "PEV",
};

export const EDIT_TEMPLATE_QUESTION_SCHEMA = {
  YES_OR_NO: "yes_or_no",
  RADIO: "radio",
  SELECT: "select",
  INPUT_MULTILINE: "input_multiline",
  INPUT_SINGLE_LINE: "input_single_line",
  INPUT_SINGLE_LINE_DISABLED: "input_single_line_disabled",
  TABLE: "table",
  LIKERT: "likert",
  DATE_PICKER: "date_picker",
  MULTIPLE_FIELDS: "multiple_fields",
  MULTIPLE_COMPONENT_DATA: "multiple_component_data", // For component_data arrays displayed in responsive grid
  SELECTION_WITH_QUESTIONS: "selection_with_questions",
  DROP_DOWN_WITH_TITLE: "drop_down_with_title",
  DROP_DOWN_WITH_TITLE_OPTION: "drop_down_with_title_option",
  INPUT_MEDICINE: "input_medicine", // For medicine input with autocomplete, dosage, and unit
  INPUT_CUSTOM_MEDICINE: "input_custom_medicine", // For dynamic medicine input API
};

export const TEMPLATE_TITLE_ENUMS = {
  HOPI: "History of Presenting Illness (HOPI) - Adult",
  HOPI_PEDIATRIC: "HOPI Pediatric (History of Presenting Illness - Pediatric)",
};

export const EDIT_TEMPLATE_MISC_ENUMS = {
  APP_VERSION: "1.0.5",
  TEMPLATE_NAME_KEY: {
    HOPI: "hopi",
    HOPI_PEDIATRIC: "hopi_pediatric",
  },
};
